import { FC } from 'react';
import { SearchIcon } from '@chakra-ui/icons';
import { Icon, Stack, Text } from '@chakra-ui/react';
import { UserType } from '../../graphql/generated';

const formatUserType = (userType?: UserType | null) => {
  switch (userType) {
    case UserType.EXTERNAL_USER:
      return 'external users';
    case UserType.INTERNAL_USER:
      return 'internal users';
    default:
      return 'users';
  }
};

type UserSearchEmptyResultProps = {
  name?: string | null;
  userType?: UserType | null;
};

export const UserSearchEmptyResult: FC<UserSearchEmptyResultProps> = ({
  name,
  userType,
}) => {
  const formattedUserType = (
    <Text as="span" fontWeight="bold" color="gray.600">
      {formatUserType(userType)}
    </Text>
  );

  const oppositeUserType =
    userType === UserType.INTERNAL_USER
      ? UserType.EXTERNAL_USER
      : UserType.INTERNAL_USER;

  const optionalName = name ? (
    <span>
      {` matching `}
      <Text as="span" fontWeight="bold" color="gray.600">
        {`"${name}"`}
      </Text>
    </span>
  ) : (
    ''
  );

  const optionalSuggestion = userType
    ? `or searching within ${formatUserType(oppositeUserType)}`
    : '';

  return (
    <Stack spacing={4} alignItems="center" data-testid="empty-result">
      <Icon as={SearchIcon} mb={4} fontSize="4xl" color="gray.300" />

      <Text fontSize="xl">
        No {formattedUserType}
        {optionalName} were found
      </Text>

      {name && (
        <Text
          fontSize="md"
          color="gray.500"
          data-testid="empty-result-suggestion"
        >
          Try adjusting your search term {optionalSuggestion}
        </Text>
      )}
    </Stack>
  );
};
